import type { FC } from "react";
import type { ISharing, ISharingStateContainerText } from "app/components/sharingAssetModal/types";
import { ESharingState } from "app/components/sharingAssetModal/types";
import styled from "styled-components";
import { Private } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/Private";
import { Account } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/Account";
import { SubsetOfUsers } from "app/components/sharingAssetModal/components/sharingStateRadioOptions/SubsetOfUsers";

interface ISharingStateContainer {
    text: ISharingStateContainerText;
    sharing: ISharing;
    setSharing: (sharing: ISharing) => void;
    disabledSharingStates: Array<ESharingState>;
    hideSharingStates: Array<ESharingState>;
    showNotificationCheckboxInMainModal?: boolean;
}
const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 32px 24px 24px 24px;
`;

export const SharingStateContainer: FC<ISharingStateContainer> = (props) => {
    const {
        text,
        sharing,
        setSharing,
        disabledSharingStates,
        hideSharingStates = [],
        showNotificationCheckboxInMainModal,
    } = props;
    const { sharingState, sharedWithUsers, notification } = sharing;
    const { PRIVATE, SUBSET_OF_USERS, ACCOUNT } = ESharingState;
    const setSharingHighOrderFunction = (attribute: keyof ISharing) => (value) => {
        setSharing({ ...sharing, [attribute]: value });
    };

    const setSharingState = setSharingHighOrderFunction("sharingState");
    const setSharedWithUsers = setSharingHighOrderFunction("sharedWithUsers");
    const setNotification = setSharingHighOrderFunction("notification");

    return (
        <Container>
            {!hideSharingStates.includes(ESharingState.PRIVATE) ? (
                <Private
                    sharingState={sharingState}
                    setSharingState={setSharingState}
                    text={text[PRIVATE]}
                    isDisabled={disabledSharingStates.includes(PRIVATE)}
                />
            ) : null}
            {!hideSharingStates.includes(ESharingState.ACCOUNT) ? (
                <Account
                    sharingState={sharingState}
                    setSharingState={setSharingState}
                    text={text[ACCOUNT]}
                    isDisabled={disabledSharingStates.includes(ACCOUNT)}
                />
            ) : null}
            {!hideSharingStates.includes(ESharingState.SUBSET_OF_USERS) ? (
                <SubsetOfUsers
                    sharingState={sharingState}
                    setSharingState={setSharingState}
                    text={text[SUBSET_OF_USERS]}
                    sharedWithUsers={sharedWithUsers}
                    setSharedWithUsers={setSharedWithUsers}
                    notification={notification}
                    setNotification={setNotification}
                    isDisabled={disabledSharingStates.includes(SUBSET_OF_USERS)}
                    hideNotificationCheckbox={showNotificationCheckboxInMainModal}
                />
            ) : null}
        </Container>
    );
};
